import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/dragon-knight/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/dragon-knight',
  name: 'activity_dragon_knight',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '破壳计划',
    expiryDate: '2024-05-23',
  },
}

export default [indexRoute]
